import { PlayerServerDots } from '@/modules/results/components/PlayerServerDots';
import { formatFirstInitialLastName } from '@/modules/results/helpers';
import { MatchType } from '@/modules/results/types';

interface MatchPlayersProps {
  match: MatchType;
  team: 1 | 2;
}

export const MatchPlayers = ({ match, team }: MatchPlayersProps) => {
  const teamMap = {
    1: {
      player1FirstName: match.team_one_player_one_first_name,
      player1LastName: match.team_one_player_one_last_name,
      player1Suffix: match.team_one_player_one_name_suffix,
      player2FirstName: match.team_one_player_two_first_name,
      player2LastName: match.team_one_player_two_last_name,
      player2Suffix: match.team_one_player_two_name_suffix,
      player1Uuid: match.team_one_player_one_uuid,
      player2Uuid: match.team_one_player_two_uuid,
      winningPercentage: match.team_one_winning_percentage,
    },
    2: {
      player1FirstName: match.team_two_player_one_first_name,
      player1LastName: match.team_two_player_one_last_name,
      player1Suffix: match.team_two_player_one_name_suffix,
      player2FirstName: match.team_two_player_two_first_name,
      player2LastName: match.team_two_player_two_last_name,
      player2Suffix: match.team_two_player_two_name_suffix,
      player1Uuid: match.team_two_player_one_uuid,
      player2Uuid: match.team_two_player_two_uuid,
      winningPercentage: match.team_one_winning_percentage,
    },
  };

  const {
    player1FirstName,
    player1LastName,
    player1Suffix,
    player2FirstName,
    player2LastName,
    player2Suffix,
  } = teamMap[team];

  const p1FName = player1FirstName || '';
  const p1LName = player1LastName || '';
  const p1Suffix = player1Suffix || '';
  const p2FName = player2FirstName || '';
  const p2LName = player2LastName || '';
  const p2Suffix = player2Suffix || '';
  // let winPercentage = Number(match[winning_percentage]) || 0;

  // if (team === 2) winPercentage = 100 - winPercentage;

  const p1IsServer =
    team === 1
      ? match.server === 1 && match.server_from_team === 1
      : match.server === 2 && match.server_from_team === 1;
  const p2IsServer =
    team === 1
      ? match.server === 1 && match.server_from_team === 2
      : match.server === 2 && match.server_from_team === 2;
  const secondServerDot =
    team === 1
      ? match.server === 1 && match.current_serving_number === 2
      : match.server === 2 && match.current_serving_number === 2;

  // const checkNames = () => {
  // 	if (match.format_title === 'Doubles') {
  // 		if (p1Name === '' || p2Name === '') {
  // 			return false;
  // 		} else {
  // 			return true;
  // 		}
  // 	} else {
  // 		if (p1Name === '') {
  // 			return false;
  // 		} else {
  // 			return true;
  // 		}
  // 	}
  // };

  return (
    <div
      className={`flex items-center gap-3 p-3 text-[12px] sm:text-[15px] ${
        match.winner === team && match.match_status === 4
          ? 'font-semibold text-gray-800'
          : 'text-gray-600'
      }`}
    >
      <h4 className='flex flex-col gap-1'>
        {p1FName ? (
          <div className='flex gap-2 items-center'>
            <span>{formatFirstInitialLastName(p1FName, p1LName, p1Suffix)}</span>
            <PlayerServerDots
              isServer={p1IsServer}
              showSecondDot={secondServerDot}
              matchStatus={match.match_status}
            />
          </div>
        ) : null}
        {p2FName ? (
          <div className='flex gap-2 items-center'>
            <span>{formatFirstInitialLastName(p2FName, p2LName, p2Suffix)}</span>
            <PlayerServerDots
              isServer={p2IsServer}
              showSecondDot={secondServerDot}
              matchStatus={match.match_status}
            />
          </div>
        ) : null}
        {!p1FName && !p2FName && 'TBD'}
      </h4>
      {/* {winPercentage && checkNames() ? (
				<span className="ml-1 block text-xs font-semibold sm:inline-block">
					<span className={Math.round(winPercentage) > 49 ? 'text-[#79d57d]' : 'text-[#ea5455]'}>{Math.round(winPercentage)}%</span>
				</span>
			) : null} */}
    </div>
  );
};
